import { ChangeDetectorRef, Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';
import { IProject } from '../petl-types';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-petl-promoted-ng',
    styleUrls: ['../../sharedStyles/base.scss', '../petl-base.scss', './promoted.component.scss'],
    templateUrl: './promoted.component.html'
})

export class PetlPromotedComponent extends PetlBaseComponent {

    constructor(_vcr: ViewContainerRef, protected readonly petlService: PetlService, protected readonly cdr: ChangeDetectorRef) {
        super(_vcr, petlService, cdr);
        this.showIssues = false;
    }

    get errorCount() {
        const promoteReport = this.petlService.project.promoteReport;
        let errorCount = 0;
        if (promoteReport) {
            for (const scenario of promoteReport.scenarios) {
                errorCount = errorCount + scenario.errors.length;
            }
        }
        return errorCount;
    }

    get projectHasPromoteResults() {
        return this.project && (this.project.lineCount || this.project.pointCount || this.project.promoteReport);
    }

    get project(): IProject {
        return this.service.project;
    }

    toggleShowIssues() {
        this.showIssues = !this.showIssues;
    }

    startOver() {
        this.petlService.startOver();
    }

}
